define('Utility/ErrorHandler',["jquery"], function($) {
    "use strict";

    var logErrorUrl = "/lnrs/logerror";

    function ErrorHandler() {
        this.logError = function logError(err) {
            if (!err) {
                return;
            }

            err = String(err);
            $.post(logErrorUrl, { message: err }).fail(function () {
                (console.error || console.log).call(console, "Failed to log error on server: " + err);
            });
        };
    }

    return new ErrorHandler();
});
